
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserManagementService } from 'src/app/contract/shared/user-management.service';

import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { UserService } from 'src/app/shared/user.service';
import { Role } from 'src/app/contract/shared/role.model';
import { ModulesSubmodulesPermissionsByRole } from 'src/app/contract/shared/modules-submodules-permissions-by-role.model';
import { PermissionsMaster } from 'src/app/contract/shared/permissions-master.model';

// export class MyErrorStateMatcher implements ErrorStateMatcher {
//   isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
//     const isSubmitted = form && form.submitted;
//     return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
//   }
// }

@Component({
  selector: 'app-role-form',
  templateUrl: './role-form.component.html',
  styleUrls: ['./role-form.component.css']
})
// export class RoleFormComponent implements OnInit {

//   module_submodule_permissions_disables: { [key: string]: { [key: number]: boolean | null } } = {};
//   module_submodule_permissions: { [key: string]: { [key: number]: boolean } } = {};

//   formLoading: boolean = false;
//   roleForm: FormGroup;
//   role: Role
//   mode: string;
//   id: string;
//   matcher = new MyErrorStateMatcher();
//   isLoading: boolean = false;
//   permissions: any[] = [];


//   commaSeparatedPermissionsBySubmoduleID = {};
//   selectedModuleinUI = 1;
//   modules: any;
//   selectedModule: number;

//   constructor(private cdr: ChangeDetectorRef, public usermanagementService: UserManagementService, public userService: UserService, private router: Router, private route: ActivatedRoute, private formBuilder: FormBuilder) {

//     this.route.params.subscribe(params => {
//       this.id = params['id'];
//       this.mode = params['mode'];
//     });

//     if (this.mode)
//       this.formLoading = true;

//     this.roleForm = this.formBuilder.group({
//       name: ['', [Validators.required]],
//       description: ['', [Validators.required]],
//       tenantId: [null],
//       status: [null],
//     });

//     this.roleForm.get('tenantId').disable();




//     this.usermanagementService.getmodulesSubmodulesPermissionsMaster().then((r) => {

//       this.usermanagementService.getAllPermissionsMaster().then((r) => {



















//         console.log("modulesSubmodulesPermissionsMaster");
//         console.log(this.usermanagementService.modulesSubmodulesPermissionsMaster);



//         if (this.route.snapshot.paramMap.get("mode") == "edit") {




//           for (let k = 0; k < this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs.length; k++) {

//             for (let l = 0; l < this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs.length; l++) {


//               this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id] = {};
//               this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][1] = null;
//               this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][2] = null;
//               this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][3] = null;
//               this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][4] = null;
//               this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][5] = null;
//               this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][6] = null;


//               for (let m = 0; m < this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].permissionDTOs.length; m++) {

//                 this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].permissionDTOs[m].id] = false;
//               }

//             }
//             if (k == this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs.length - 1) {
//               console.log("THi is module_submodule_permissions_disables");
//               console.log(this.module_submodule_permissions_disables);
//             }
//           }

//           // this.usermanagementService.thisUserModulePermissionRoles[0] = new ModulesSubmodulesPermissionsByRole();
//           document.getElementById('loader').style.display = 'block';
//           this.usermanagementService.getRole(this.route.snapshot.paramMap.get("id")).then((res) => {
//             this.usermanagementService.getPermissions(this.route.snapshot.paramMap.get("id")).then((res) => {
//               console.log("thisUserModulePermissionRoles");
//               console.log(this.usermanagementService.thisUserModulePermissionRoles);
//               for (let i = 0; i < this.usermanagementService.thisUserModulePermissionRoles.length; i++) {
//                 if (this.commaSeparatedPermissionsBySubmoduleID[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId] == null)
//                   this.commaSeparatedPermissionsBySubmoduleID[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId] = {};
//                 this.commaSeparatedPermissionsBySubmoduleID[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId][this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId] = this.usermanagementService.thisUserModulePermissionRoles[i].permissionIds;


//                 this.module_submodule_permissions[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId + "-" + this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId] = {};
//                 //   this.module_submodule_permissions[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId][this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId] = {};

//                 var is_nextAllDisabled = false;
//                 for (let j = 0; j < this.usermanagementService.thisPermissionsMater.length; j++) {
//                   if (is_nextAllDisabled) {
//                     if (this.module_submodule_permissions_disables[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId + "-" + this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId][this.usermanagementService.thisPermissionsMater[j].id] != null) {
//                       this.module_submodule_permissions_disables[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId + "-" + this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId][this.usermanagementService.thisPermissionsMater[j].id] = true;
//                     }
//                   }
//                   this.module_submodule_permissions[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId + "-" + this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId][this.usermanagementService.thisPermissionsMater[j].id] = false;
//                   if (this.usermanagementService.thisUserModulePermissionRoles[i].permissionIds.indexOf(this.usermanagementService.thisPermissionsMater[j].id.toString()) >= 0) {
//                     this.module_submodule_permissions[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId + "-" + this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId][this.usermanagementService.thisPermissionsMater[j].id] = true;
//                     if (!is_nextAllDisabled) {
//                       if (this.usermanagementService.thisPermissionsMater[j].id == 1 || this.usermanagementService.thisPermissionsMater[j].id == 2 || this.usermanagementService.thisPermissionsMater[j].id == 3) {
//                         is_nextAllDisabled = true;
//                       }
//                     }
//                   }



//                 }

//                 if (i == this.usermanagementService.thisUserModulePermissionRoles.length - 1) {
//                   document.getElementById('loader').style.display = 'none';
//                   this.cdr.detectChanges();
//                 }

//               }
//               console.log("THis is comma separated permissions IDs");
//               console.log(this.commaSeparatedPermissionsBySubmoduleID);
//               console.log(this.module_submodule_permissions);

//               // document.getElementById('loader').style.display='none';
//             });

//           });
//         } else if (this.route.snapshot.paramMap.get("mode") == "new") {




//           for (let k = 0; k < this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs.length; k++) {

//             for (let l = 0; l < this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs.length; l++) {


//               this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id] = {};
//               this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][1] = null;
//               this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][2] = null;
//               this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][3] = null;
//               this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][4] = null;
//               this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][5] = null;
//               this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][6] = null;


//               for (let m = 0; m < this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].permissionDTOs.length; m++) {

//                 this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].permissionDTOs[m].id] = false;
//               }

//             }
//             if (k == this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs.length - 1) {
//               console.log("THi is module_submodule_permissions_disables");
//               console.log(this.module_submodule_permissions_disables);
//             }
//           }





//           this.usermanagementService.thisRole = new Role();
//           this.usermanagementService.thisRole.tenantId = this.userService.loggedinUser.tenantId;
//           let noOfSubModules = 0;
//           for (let i = 0; i < this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs.length; i++) {
//             this.commaSeparatedPermissionsBySubmoduleID[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[i].id] = {};
//             for (let j = 0; j < this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[i].subModuleDTOs.length; j++) {
//               this.usermanagementService.thisUserModulePermissionRoles[noOfSubModules] = new ModulesSubmodulesPermissionsByRole();
//               this.usermanagementService.thisUserModulePermissionRoles[noOfSubModules].moduleId = this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[i].id;
//               // this.usermanagementService.thisUserModulePermissionRoles[noOfSubModules].roleId =  this.usermanagementService.thisRole.id;
//               this.usermanagementService.thisUserModulePermissionRoles[noOfSubModules].tenantId = this.userService.loggedinUser.tenantId;
//               this.usermanagementService.thisUserModulePermissionRoles[noOfSubModules].createdBy = this.userService.loggedinUser.firstName + " " + this.userService.loggedinUser.lastName;
//               this.usermanagementService.thisUserModulePermissionRoles[noOfSubModules].status = 1;
//               this.usermanagementService.thisUserModulePermissionRoles[noOfSubModules].updatedBy = this.userService.loggedinUser.firstName + " " + this.userService.loggedinUser.lastName;
//               this.usermanagementService.thisUserModulePermissionRoles[noOfSubModules].subModuleId = this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[i].subModuleDTOs[j].id;
//               this.commaSeparatedPermissionsBySubmoduleID[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[i].id][this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[i].subModuleDTOs[j].id] = "";

//               this.module_submodule_permissions[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[i].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[i].subModuleDTOs[j].id] = {};
//               for (let k = 0; k < this.usermanagementService.thisPermissionsMater.length; k++) {

//                 this.module_submodule_permissions[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[i].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[i].subModuleDTOs[j].id][this.usermanagementService.thisPermissionsMater[k].id] = false;
//                 /* if( this.usermanagementService.thisUserModulePermissionRoles[noOfSubModules].permissionIds.indexOf(this.usermanagementService.thisPermissionsMater[k].id.toString()) >=0){
//                    this.module_submodule_permissions[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[i].id+"-"+this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[i].subModuleDTOs[j].id][this.usermanagementService.thisPermissionsMater[k].id] = true;
    
//                  }*/



//               }
//               noOfSubModules++;
//             }
//           }
//           //  console.log(this.usermanagementService.thisUserModulePermissionRoles);
//         }


//         else {



//           for (let k = 0; k < this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs.length; k++) {

//             for (let l = 0; l < this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs.length; l++) {


//               this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id] = {};
//               this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][1] = null;
//               this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][2] = null;
//               this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][3] = null;
//               this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][4] = null;
//               this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][5] = null;
//               this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][6] = null;


//               /* for(let m =0;m<this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].permissionDTOs.length;m++){
                
//                  this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id+"-"+this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].permissionDTOs[m].id] = false;
//                }*/

//             }
//             if (k == this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs.length - 1) {
//               console.log("THi is module_submodule_permissions_disables");
//               console.log(this.module_submodule_permissions_disables);
//             }
//           }  
 
//           // this.usermanagementService.thisUserModulePermissionRoles[0] = new ModulesSubmodulesPermissionsByRole();
//           document.getElementById('loader').style.display = 'block';
//           this.usermanagementService.getRole(this.route.snapshot.paramMap.get("id")).then((res) => {
//             this.usermanagementService.getPermissions(this.route.snapshot.paramMap.get("id")).then((res) => {
//               console.log("thisUserModulePermissionRoles");
//               console.log(this.usermanagementService.thisUserModulePermissionRoles);
//               for (let i = 0; i < this.usermanagementService.thisUserModulePermissionRoles.length; i++) {
//                 if (this.commaSeparatedPermissionsBySubmoduleID[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId] == null)
//                   this.commaSeparatedPermissionsBySubmoduleID[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId] = {};
//                 this.commaSeparatedPermissionsBySubmoduleID[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId][this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId] = this.usermanagementService.thisUserModulePermissionRoles[i].permissionIds;


//                 this.module_submodule_permissions[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId + "-" + this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId] = {};
//                 //   this.module_submodule_permissions[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId][this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId] = {};

//                 var is_nextAllDisabled = false;
//                 for (let j = 0; j < this.usermanagementService.thisPermissionsMater.length; j++) {
//                   if (is_nextAllDisabled) {
//                     if (this.module_submodule_permissions_disables[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId + "-" + this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId][this.usermanagementService.thisPermissionsMater[j].id] != null) {
//                       this.module_submodule_permissions_disables[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId + "-" + this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId][this.usermanagementService.thisPermissionsMater[j].id] = true;
//                     }
//                   }
//                   this.module_submodule_permissions[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId + "-" + this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId][this.usermanagementService.thisPermissionsMater[j].id] = false;
//                   if (this.usermanagementService.thisUserModulePermissionRoles[i].permissionIds.indexOf(this.usermanagementService.thisPermissionsMater[j].id.toString()) >= 0) {
//                     this.module_submodule_permissions[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId + "-" + this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId][this.usermanagementService.thisPermissionsMater[j].id] = true;
//                     if (!is_nextAllDisabled) {
//                       if (this.usermanagementService.thisPermissionsMater[j].id == 1 || this.usermanagementService.thisPermissionsMater[j].id == 2 || this.usermanagementService.thisPermissionsMater[j].id == 3) {
//                         is_nextAllDisabled = true;
//                       }
//                     }
//                   }



//                 }

//                 if (i == this.usermanagementService.thisUserModulePermissionRoles.length - 1) {
//                   document.getElementById('loader').style.display = 'none';
//                   this.cdr.detectChanges();
//                 }

//               }
//               console.log("THis is comma separated permissions IDs");
//               console.log(this.commaSeparatedPermissionsBySubmoduleID);
//               console.log(this.module_submodule_permissions);

//               // document.getElementById('loader').style.display='none';
//             });

//           });


//         }

//       })


//     });
//     /*this.usermanagementService.getAllPermissionsMaster().then((r)=>{
//       console.log("thisPermissionsMater");
//       console.log(this.usermanagementService.thisPermissionsMater);
//     });*/
//   }

//   onModuleSelect(event) {
//     this.selectedModule = event.value;
//   }

//   async ngOnInit() {
//     await this.usermanagementService.getmodulesSubmodulesPermissionsMaster().then((res: any) => {
//       this.modules = res.moduleDTOs;
//     });
//     await this.usermanagementService.getAllPermissionsMaster().then((res: any) => {
//       this.permissions = res;
//     });

// //     this.modules.forEach((module) => {
// //   module.subModuleDTOs.forEach((subModule) => {
// //     const key = `${module.id}-${subModule.id}`;

// //     // Initialize module_submodule_permissions
// //     this.module_submodule_permissions[key] = {};
// //     for (let i = 1; i <= 6; i++) {
// //       this.module_submodule_permissions[key][i] = false;
// //     }

// //     // Initialize module_submodule_permissions_disables
// //     this.module_submodule_permissions_disables[key] = {};
// //     for (let i = 1; i <= 6; i++) {
// //       this.module_submodule_permissions_disables[key][i] = null;
// //     }

// //     subModule.permissionDTOs.forEach((permission) => {
// //       this.module_submodule_permissions[key][permission.id] = false;
// //       this.module_submodule_permissions_disables[key][permission.id] = false;
// //     });
// //   });
// // });

    

//     this.modules.forEach((module) => {
//       module.subModuleDTOs.forEach((subModule) => {
//         const key = `${module.id}-${subModule.id}`;

//         this.module_submodule_permissions_disables[key] = subModule.permissionDTOs.reduce((acc, permission) => {
//           acc[permission.id] = null;
//           return acc;
//         }, {} as { [key: number]: boolean | null });

//         // Initialize module-submodule permissions
//         this.module_submodule_permissions[key] = subModule.permissionDTOs.reduce((acc, permission) => {
//           acc[permission.id] = false;
//           return acc;
//         }, {} as { [key: number]: boolean });
//       });
//     });

//     this.modules.forEach(module => {
//       module.subModuleDTOs.forEach(subModule => {
//         subModule.permissionDTOs.forEach(permission => {
//           const controlName = `permissionValue-${module.id}-${subModule.id}-${permission.id}`;
//           this.roleForm.addControl(controlName, this.formBuilder.control(false));
//         });
//       });
//     });

//   }

//   isPermissionDisabled(moduleId: number, submoduleId: number, permissionId: number): boolean {
//     const key = `${moduleId}-${submoduleId}`;
//     const disableStatus = this.module_submodule_permissions_disables[key][permissionId];
//     return disableStatus === null ? true : disableStatus;
//   }



//   createRole(status: boolean) {

//     this.usermanagementService.thisRole.status = (status ? 1 : 0);
//     if (this.route.snapshot.paramMap.get("mode") == "edit") {
//       this.usermanagementService.updateRole(status).then((res) => {
//         for (let i = 0; i < this.usermanagementService.thisUserModulePermissionRoles.length; i++) {

//           this.usermanagementService.thisUserModulePermissionRoles[i].permissionIds = this.commaSeparatedPermissionsBySubmoduleID[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId][this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId];
//         }
//         this.usermanagementService.updatePermissions().then((res) => {
//           this.usermanagementService.userCreationConfirmationAlert = true;
//           this.usermanagementService.alertMessage = "Role has been updated Succussfully!!";
//           this.router.navigate(["/app/role/list"]).then((r) => {

//           });
//         });
//       });
//     }
//     else if (this.route.snapshot.paramMap.get("mode") == "new") {
//       this.usermanagementService.createRole().then((res) => {
//         for (let i = 0; i < this.usermanagementService.thisUserModulePermissionRoles.length; i++) {
//           this.usermanagementService.thisUserModulePermissionRoles[i].roleId = this.usermanagementService.thisRole.id;
//           this.usermanagementService.thisUserModulePermissionRoles[i].permissionIds = this.commaSeparatedPermissionsBySubmoduleID[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId][this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId];
//         }

//         this.usermanagementService.createPermissions().then((res) => {
//           this.usermanagementService.userCreationConfirmationAlert = true;
//           this.usermanagementService.alertMessage = "Role has been created Succussfully!!";
//           this.router.navigate(["/app/role/list"]).then((r) => {

//           });
//         });

//       });
//     }
//   }


//   AutoToggle(value, permission_id, subModule_id, module_id) {

//     if (this.module_submodule_permissions_disables[module_id + "-" + subModule_id][permission_id] != null) {
//       let temp = [];
//       if (this.commaSeparatedPermissionsBySubmoduleID[module_id][subModule_id].length > 0)
//         temp = this.commaSeparatedPermissionsBySubmoduleID[module_id][subModule_id].split(',');
//       if (value) {
//         if (temp.indexOf(permission_id.toString()) < 0) {
//           temp.push(permission_id.toString());
//         }
//       } else {
//         if (temp.indexOf(permission_id.toString()) >= 0) {
//           temp.splice(temp.indexOf(permission_id.toString()), 1);
//         }
//       }
//       this.commaSeparatedPermissionsBySubmoduleID[module_id][subModule_id] = temp.join();

//       this.module_submodule_permissions[module_id + '-' + subModule_id][permission_id] = value;


//       if (value) {
//         this.module_submodule_permissions_disables[module_id + "-" + subModule_id][permission_id] = true;
//       }
//       else {
//         this.module_submodule_permissions_disables[module_id + "-" + subModule_id][permission_id] = false;
//       }
//     }

//   }
//   toggle(e, permission_id, subModule_id, module_id, index) {
//     let temp = [];
//     if (this.commaSeparatedPermissionsBySubmoduleID[module_id][subModule_id].length > 0)
//       temp = this.commaSeparatedPermissionsBySubmoduleID[module_id][subModule_id].split(',');
//     if (e.target.checked) {
//       if (temp.indexOf(permission_id.toString()) < 0) {
//         temp.push(permission_id.toString());
//       }
//     } else {
//       if (temp.indexOf(permission_id.toString()) >= 0) {
//         temp.splice(temp.indexOf(permission_id.toString()), 1);
//       }
//     }
//     this.commaSeparatedPermissionsBySubmoduleID[module_id][subModule_id] = temp.join();
//     if (permission_id == 1) {
//       this.AutoToggle(e.target.checked, 2, subModule_id, module_id);

//       this.AutoToggle(e.target.checked, 3, subModule_id, module_id);
//       this.AutoToggle(e.target.checked, 4, subModule_id, module_id);
//       this.AutoToggle(e.target.checked, 5, subModule_id, module_id);
//       this.AutoToggle(e.target.checked, 6, subModule_id, module_id);

//     }
//     if (permission_id == 2) {
//       // this.AutoToggle(e.target.checked,2,subModule_id,module_id);

//       this.AutoToggle(e.target.checked, 3, subModule_id, module_id);
//       this.AutoToggle(e.target.checked, 4, subModule_id, module_id);
//       this.AutoToggle(e.target.checked, 5, subModule_id, module_id);
//       this.AutoToggle(e.target.checked, 6, subModule_id, module_id);

//     }
//     if (permission_id == 3) {
//       // this.AutoToggle(e.target.checked,2,subModule_id,module_id);

//       // this.AutoToggle(e.target.checked,3,subModule_id,module_id);
//       this.AutoToggle(e.target.checked, 4, subModule_id, module_id);
//       this.AutoToggle(e.target.checked, 5, subModule_id, module_id);
//       this.AutoToggle(e.target.checked, 6, subModule_id, module_id);

//     }

//   }

//   // AutoToggle(value: boolean, permissionId: number, subModuleId: number, moduleId: number): void {

//   //   const controlName = `permissionValue-${moduleId}-${subModuleId}-${permissionId}`;
//   //   const control = this.roleForm.get(controlName);
  
//   //   if (control) {
//   //     const temp = this.commaSeparatedPermissionsBySubmoduleID[moduleId][subModuleId].split(',');
  
//   //     if (control.value !== null) {
//   //       if (value && !temp.includes(permissionId.toString())) {
//   //         temp.push(permissionId.toString());
//   //       } else if (!value && temp.includes(permissionId.toString())) {
//   //         temp.splice(temp.indexOf(permissionId.toString()), 1);
//   //       }
  
//   //       this.commaSeparatedPermissionsBySubmoduleID[moduleId][subModuleId] = temp.join();
//   //       control.setValue(value);
//   //       this.updateDisableStatus(value, permissionId, subModuleId, moduleId);
//   //     }
//   //   }
//   // }
  
//   updateDisableStatus(value: boolean, permissionId: number, subModuleId: number, moduleId: number): void {

//     if (permissionId >= 1 && permissionId <= 3) {
//       for (let i = permissionId + 1; i <= 6; i++) {
//         this.AutoToggle(value, i, subModuleId, moduleId);
//       }
//     }
//   }
  
//   // toggle(permissionId: number, subModuleId: number, moduleId: number): void {
//   //   const controlName = `permissionValue-${moduleId}-${subModuleId}-${permissionId}`;
//   //   const control = this.roleForm.get(controlName);
  
//   //   if (control) {
//   //     const temp = this.commaSeparatedPermissionsBySubmoduleID[moduleId][subModuleId].split(',');
  
//   //     if (control.value !== null) {
//   //       if (control.value && !temp.includes(permissionId.toString())) {
//   //         temp.push(permissionId.toString());
//   //       } else if (!control.value && temp.includes(permissionId.toString())) {
//   //         temp.splice(temp.indexOf(permissionId.toString()), 1);
//   //       }
  
//   //       this.commaSeparatedPermissionsBySubmoduleID[moduleId][subModuleId] = temp.join();
//   //       this.updateDisableStatus(control.value, permissionId, subModuleId, moduleId);
//   //     }
//   //   }
//   // }
  

//   reset() {
//     this.roleForm.reset();
//   }

// }
export class RoleFormComponent implements OnInit {
  
  id: string | null = null; // Assuming the role's ID could be a string or null
  formLoading: boolean = false;
  hideNavbar: boolean = true;
  commaSeparatedPermissionsBySubmoduleID = {};
  selectedModuleinUI = null;
  module_submodule_permissions = {};
  module_submodule_permissions_disables = {};
  mode = null;
  constructor(private cdr: ChangeDetectorRef, public usermanagementService: UserManagementService, public userService: UserService, private router: Router, private route: ActivatedRoute) {
    this.mode = this.route.snapshot.paramMap.get("mode");
    console.log("mode");
    // console.log(this.userService.loggedinPermissions['_USER_MANAGEMENT_EDIT_']);

    this.usermanagementService.getmodulesSubmodulesPermissionsMaster().then((r) => {

      this.usermanagementService.getAllPermissionsMaster().then((r) => {

        console.log("modulesSubmodulesPermissionsMaster");
        console.log(this.usermanagementService.modulesSubmodulesPermissionsMaster);



        if (this.route.snapshot.paramMap.get("mode") == "edit") {




          for (let k = 0; k < this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs.length; k++) {

            for (let l = 0; l < this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs.length; l++) {


              this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id] = {};
              this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][1] = null;
              this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][2] = null;
              this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][3] = null;
              this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][4] = null;
              this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][5] = null;
              this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][6] = null;


              for (let m = 0; m < this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].permissionDTOs.length; m++) {

                this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].permissionDTOs[m].id] = false;
              }

            }
            if (k == this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs.length - 1) {
              console.log("THi is module_submodule_permissions_disables");
              console.log(this.module_submodule_permissions_disables);
            }
          }

          // this.usermanagementService.thisUserModulePermissionRoles[0] = new ModulesSubmodulesPermissionsByRole();
          this.usermanagementService.getRole(this.route.snapshot.paramMap.get("id")).then((res) => {
            this.usermanagementService.getPermissions(this.route.snapshot.paramMap.get("id")).then((res) => {
              console.log("thisUserModulePermissionRoles");
              console.log(this.usermanagementService.thisUserModulePermissionRoles);
              for (let i = 0; i < this.usermanagementService.thisUserModulePermissionRoles.length; i++) {
                if (this.commaSeparatedPermissionsBySubmoduleID[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId] == null)
                  this.commaSeparatedPermissionsBySubmoduleID[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId] = {};
                this.commaSeparatedPermissionsBySubmoduleID[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId][this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId] = this.usermanagementService.thisUserModulePermissionRoles[i].permissionIds;


                this.module_submodule_permissions[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId + "-" + this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId] = {};
                //   this.module_submodule_permissions[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId][this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId] = {};

                var is_nextAllDisabled = false;
                for (let j = 0; j < this.usermanagementService.thisPermissionsMater.length; j++) {
                  if (is_nextAllDisabled) {
                    if (this.module_submodule_permissions_disables[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId + "-" + this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId][this.usermanagementService.thisPermissionsMater[j].id] != null) {
                      this.module_submodule_permissions_disables[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId + "-" + this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId][this.usermanagementService.thisPermissionsMater[j].id] = true;
                    }
                  }
                  this.module_submodule_permissions[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId + "-" + this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId][this.usermanagementService.thisPermissionsMater[j].id] = false;
                  if (this.usermanagementService.thisUserModulePermissionRoles[i].permissionIds.indexOf(this.usermanagementService.thisPermissionsMater[j].id.toString()) >= 0) {
                    this.module_submodule_permissions[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId + "-" + this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId][this.usermanagementService.thisPermissionsMater[j].id] = true;
                    if (!is_nextAllDisabled) {
                      if (this.usermanagementService.thisPermissionsMater[j].id == 1 || this.usermanagementService.thisPermissionsMater[j].id == 2 || this.usermanagementService.thisPermissionsMater[j].id == 3) {
                        is_nextAllDisabled = true;
                      }
                    }
                  }



                }

                if (i == this.usermanagementService.thisUserModulePermissionRoles.length - 1) {
                  this.cdr.detectChanges();
                }

              }
              console.log("THis is comma separated permissions IDs");
              console.log(this.commaSeparatedPermissionsBySubmoduleID);
              console.log(this.module_submodule_permissions);

              // document.getElementById('loader').style.display='none';
            });

          });
        } else if (this.route.snapshot.paramMap.get("mode") == "new") {




          for (let k = 0; k < this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs.length; k++) {

            for (let l = 0; l < this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs.length; l++) {


              this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id] = {};
              this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][1] = null;
              this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][2] = null;
              this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][3] = null;
              this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][4] = null;
              this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][5] = null;
              this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][6] = null;


              for (let m = 0; m < this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].permissionDTOs.length; m++) {

                this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].permissionDTOs[m].id] = false;
              }

            }
            if (k == this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs.length - 1) {
              console.log("THi is module_submodule_permissions_disables");
              console.log(this.module_submodule_permissions_disables);
            }
          }





          this.usermanagementService.thisRole = new Role();
          this.usermanagementService.thisRole.tenantId = this.userService.loggedinUser.tenantId;
          let noOfSubModules = 0;
          for (let i = 0; i < this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs.length; i++) {
            this.commaSeparatedPermissionsBySubmoduleID[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[i].id] = {};
            for (let j = 0; j < this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[i].subModuleDTOs.length; j++) {
              this.usermanagementService.thisUserModulePermissionRoles[noOfSubModules] = new ModulesSubmodulesPermissionsByRole();
              this.usermanagementService.thisUserModulePermissionRoles[noOfSubModules].moduleId = this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[i].id;
              // this.usermanagementService.thisUserModulePermissionRoles[noOfSubModules].roleId =  this.usermanagementService.thisRole.id;
              this.usermanagementService.thisUserModulePermissionRoles[noOfSubModules].tenantId = this.userService.loggedinUser.tenantId;
              this.usermanagementService.thisUserModulePermissionRoles[noOfSubModules].createdBy = this.userService.loggedinUser.firstName + " " + this.userService.loggedinUser.lastName;
              this.usermanagementService.thisUserModulePermissionRoles[noOfSubModules].status = 1;
              this.usermanagementService.thisUserModulePermissionRoles[noOfSubModules].updatedBy = this.userService.loggedinUser.firstName + " " + this.userService.loggedinUser.lastName;
              this.usermanagementService.thisUserModulePermissionRoles[noOfSubModules].subModuleId = this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[i].subModuleDTOs[j].id;
              this.commaSeparatedPermissionsBySubmoduleID[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[i].id][this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[i].subModuleDTOs[j].id] = "";

              this.module_submodule_permissions[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[i].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[i].subModuleDTOs[j].id] = {};
              for (let k = 0; k < this.usermanagementService.thisPermissionsMater.length; k++) {

                this.module_submodule_permissions[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[i].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[i].subModuleDTOs[j].id][this.usermanagementService.thisPermissionsMater[k].id] = false;
                /* if( this.usermanagementService.thisUserModulePermissionRoles[noOfSubModules].permissionIds.indexOf(this.usermanagementService.thisPermissionsMater[k].id.toString()) >=0){
                   this.module_submodule_permissions[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[i].id+"-"+this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[i].subModuleDTOs[j].id][this.usermanagementService.thisPermissionsMater[k].id] = true;
    
                 }*/



              }
              noOfSubModules++;
            }
          }
          //  console.log(this.usermanagementService.thisUserModulePermissionRoles);
        }


        else {



          for (let k = 0; k < this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs.length; k++) {

            for (let l = 0; l < this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs.length; l++) {


              this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id] = {};
              this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][1] = null;
              this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][2] = null;
              this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][3] = null;
              this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][4] = null;
              this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][5] = null;
              this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id + "-" + this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][6] = null;


              /* for(let m =0;m<this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].permissionDTOs.length;m++){
                
                 this.module_submodule_permissions_disables[this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].id+"-"+this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].id][this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs[k].subModuleDTOs[l].permissionDTOs[m].id] = false;
               }*/

            }
            if (k == this.usermanagementService.modulesSubmodulesPermissionsMaster.moduleDTOs.length - 1) {
              console.log("THi is module_submodule_permissions_disables");
              console.log(this.module_submodule_permissions_disables);
            }
          }  
 
          // this.usermanagementService.thisUserModulePermissionRoles[0] = new ModulesSubmodulesPermissionsByRole();
          this.usermanagementService.getRole(this.route.snapshot.paramMap.get("id")).then((res) => {
            this.usermanagementService.getPermissions(this.route.snapshot.paramMap.get("id")).then((res) => {
              console.log("thisUserModulePermissionRoles");
              console.log(this.usermanagementService.thisUserModulePermissionRoles);
              for (let i = 0; i < this.usermanagementService.thisUserModulePermissionRoles.length; i++) {
                if (this.commaSeparatedPermissionsBySubmoduleID[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId] == null)
                  this.commaSeparatedPermissionsBySubmoduleID[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId] = {};
                this.commaSeparatedPermissionsBySubmoduleID[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId][this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId] = this.usermanagementService.thisUserModulePermissionRoles[i].permissionIds;


                this.module_submodule_permissions[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId + "-" + this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId] = {};
                //   this.module_submodule_permissions[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId][this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId] = {};

                var is_nextAllDisabled = false;
                for (let j = 0; j < this.usermanagementService.thisPermissionsMater.length; j++) {
                  if (is_nextAllDisabled) {
                    if (this.module_submodule_permissions_disables[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId + "-" + this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId][this.usermanagementService.thisPermissionsMater[j].id] != null) {
                      this.module_submodule_permissions_disables[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId + "-" + this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId][this.usermanagementService.thisPermissionsMater[j].id] = true;
                    }
                  }
                  this.module_submodule_permissions[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId + "-" + this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId][this.usermanagementService.thisPermissionsMater[j].id] = false;
                  if (this.usermanagementService.thisUserModulePermissionRoles[i].permissionIds.indexOf(this.usermanagementService.thisPermissionsMater[j].id.toString()) >= 0) {
                    this.module_submodule_permissions[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId + "-" + this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId][this.usermanagementService.thisPermissionsMater[j].id] = true;
                    if (!is_nextAllDisabled) {
                      if (this.usermanagementService.thisPermissionsMater[j].id == 1 || this.usermanagementService.thisPermissionsMater[j].id == 2 || this.usermanagementService.thisPermissionsMater[j].id == 3) {
                        is_nextAllDisabled = true;
                      }
                    }
                  }



                }

                if (i == this.usermanagementService.thisUserModulePermissionRoles.length - 1) {
                  this.cdr.detectChanges();
                }

              }
              console.log("THis is comma separated permissions IDs");
              console.log(this.commaSeparatedPermissionsBySubmoduleID);
              console.log(this.module_submodule_permissions);

              // document.getElementById('loader').style.display='none';
            });

          });


        }

      })


    });
    /*this.usermanagementService.getAllPermissionsMaster().then((r)=>{
      console.log("thisPermissionsMater");
      console.log(this.usermanagementService.thisPermissionsMater);
    });*/

  }

  ngOnInit(): void {
  }
  tab(id: string) {
    //  alert(id);
    var otherone = (id == 'nav-permission') ? 'nav-role' : 'nav-permission';
    var element = document.getElementById(id);
    var otherone_element = document.getElementById(otherone);
    element.classList.add("active");
    element.classList.add("show");
    otherone_element.classList.remove("active");
    otherone_element.classList.remove("show");



  }

  createRole(status: boolean) {

    
    console.log(this.usermanagementService.thisRole);
    console.log(this.usermanagementService.thisUserModulePermissionRoles);
    console.log(this.commaSeparatedPermissionsBySubmoduleID);
    
    this.usermanagementService.thisRole.status = (status ? 1 : 0);
    if (this.route.snapshot.paramMap.get("mode") === "edit") {
      this.usermanagementService.updateRole().then((res) => {
        for (let i = 0; i < this.usermanagementService.thisUserModulePermissionRoles.length; i++) {
          this.usermanagementService.thisUserModulePermissionRoles[i].permissionIds =
            this.commaSeparatedPermissionsBySubmoduleID[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId]
            [this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId];
        }
        this.usermanagementService.updatePermissions().then((res) => {
          this.usermanagementService.userCreationConfirmationAlert = true;
          this.usermanagementService.alertMessage = "Role has been updated successfully!!";
          this.router.navigate(["/app/role/list"]).then((r) => {
          });
        });
      });
    } else if (this.route.snapshot.paramMap.get("mode") === "new") {
      this.usermanagementService.createRole().then((res) => {
        for (let i = 0; i < this.usermanagementService.thisUserModulePermissionRoles.length; i++) {
          this.usermanagementService.thisUserModulePermissionRoles[i].roleId = this.usermanagementService.thisRole.id;
          this.usermanagementService.thisUserModulePermissionRoles[i].permissionIds =
            this.commaSeparatedPermissionsBySubmoduleID[this.usermanagementService.thisUserModulePermissionRoles[i].moduleId]
            [this.usermanagementService.thisUserModulePermissionRoles[i].subModuleId];
        }
  
        this.usermanagementService.createPermissions().then((res) => {
          this.usermanagementService.userCreationConfirmationAlert = true;
          this.usermanagementService.alertMessage = "Role has been created successfully!!";
          this.router.navigate(["/app/role/list"]).then((r) => {
          });
        });
      });
    }
  }
  next() {
    document.getElementById('nav-permission-tab').click();
    this.tab('nav-permission');

    let element_tab = document.getElementById('nav-permission-tab');
    let other_tab = document.getElementById('nav-role-tab');
    other_tab.classList.remove('active');
    element_tab.classList.add('active');

    element_tab.removeAttribute('disabled');

  }
  isPermissionPresent(id: number, permissions: PermissionsMaster[]) {
    for (let i = 0; i < permissions.length; i++) {
      if (permissions[i].id == id) {
        return true;
      }
    }
    return false;
  }
  cancel() {
    let decision = window.confirm("are you sure to cancel?");
    if (decision) {
      this.router.navigate(["/app/role/list"]);
    }

  }
  isChecked(permission_id, subModule_id, module_id) {
    if (!this.commaSeparatedPermissionsBySubmoduleID[module_id])
      return false;
    if (!this.commaSeparatedPermissionsBySubmoduleID[module_id][subModule_id])
      return false;
    if (this.commaSeparatedPermissionsBySubmoduleID[module_id][subModule_id].length == 0) {
      return false;
    }
    else {
      if (this.commaSeparatedPermissionsBySubmoduleID[module_id][subModule_id].split(',').indexOf(permission_id.toString()) < 0)
        return false
      else
        return true;
    }
  }
  AutoToggle(value, permission_id, subModule_id, module_id) {

    if (this.module_submodule_permissions_disables[module_id + "-" + subModule_id][permission_id] != null) {
      console.log(subModule_id);
      console.log(permission_id);
      console.log(this.commaSeparatedPermissionsBySubmoduleID);
      let temp = [];
      if (this.commaSeparatedPermissionsBySubmoduleID[module_id][subModule_id].length > 0)
        temp = this.commaSeparatedPermissionsBySubmoduleID[module_id][subModule_id].split(',');


      console.log(temp);
      if (value) {
        if (temp.indexOf(permission_id.toString()) < 0) {
          temp.push(permission_id.toString());
        }
      } else {
        if (temp.indexOf(permission_id.toString()) >= 0) {
          temp.splice(temp.indexOf(permission_id.toString()), 1);
        }
      }
      console.log(temp);
      this.commaSeparatedPermissionsBySubmoduleID[module_id][subModule_id] = temp.join();

      console.log(this.commaSeparatedPermissionsBySubmoduleID);
      this.module_submodule_permissions[module_id + '-' + subModule_id][permission_id] = value;


      if (value) {
        this.module_submodule_permissions_disables[module_id + "-" + subModule_id][permission_id] = true;
      }
      else {
        this.module_submodule_permissions_disables[module_id + "-" + subModule_id][permission_id] = false;
      }



    }



  }
  toggle(e, permission_id, subModule_id, module_id, index) {
    //  console.log(e);
    console.log(subModule_id);
    console.log(permission_id);
    console.log(this.commaSeparatedPermissionsBySubmoduleID);
    let temp = [];
    if (this.commaSeparatedPermissionsBySubmoduleID[module_id][subModule_id].length > 0)
      temp = this.commaSeparatedPermissionsBySubmoduleID[module_id][subModule_id].split(',');


    console.log(temp);
    if (e.target.checked) {
      if (temp.indexOf(permission_id.toString()) < 0) {
        temp.push(permission_id.toString());
      }
    } else {
      if (temp.indexOf(permission_id.toString()) >= 0) {
        temp.splice(temp.indexOf(permission_id.toString()), 1);
      }
    }
    console.log(temp);
    this.commaSeparatedPermissionsBySubmoduleID[module_id][subModule_id] = temp.join();

    console.log(this.commaSeparatedPermissionsBySubmoduleID);

    if (permission_id == 1) {
      this.AutoToggle(e.target.checked, 2, subModule_id, module_id);

      this.AutoToggle(e.target.checked, 3, subModule_id, module_id);
      this.AutoToggle(e.target.checked, 4, subModule_id, module_id);
      this.AutoToggle(e.target.checked, 5, subModule_id, module_id);
      this.AutoToggle(e.target.checked, 6, subModule_id, module_id);

    }
    if (permission_id == 2) {
      // this.AutoToggle(e.target.checked,2,subModule_id,module_id);

      this.AutoToggle(e.target.checked, 3, subModule_id, module_id);
      this.AutoToggle(e.target.checked, 4, subModule_id, module_id);
      this.AutoToggle(e.target.checked, 5, subModule_id, module_id);
      this.AutoToggle(e.target.checked, 6, subModule_id, module_id);

    }
    if (permission_id == 3) {
      // this.AutoToggle(e.target.checked,2,subModule_id,module_id);

      // this.AutoToggle(e.target.checked,3,subModule_id,module_id);
      this.AutoToggle(e.target.checked, 4, subModule_id, module_id);
      this.AutoToggle(e.target.checked, 5, subModule_id, module_id);
      this.AutoToggle(e.target.checked, 6, subModule_id, module_id);

    }

  }
  resetForm(form: NgForm) {
    form.resetForm();  // Resets the form fields
  }
  

}